import type { RouteRecordRaw } from 'vue-router'

const msgNoticeSetRoutes: RouteRecordRaw[] = [
  {
    path: 'msg-notice-set',
    component: () => import('@/pages/msg-notice-set/layout.vue'),
    meta: { title: '消息提醒', parent: '客户运营' },
    children: [
      { path: '', redirect: { name: 'MessageNoticeConfigs' } },
      {
        path: 'configs',
        name: 'MessageNoticeConfigs',
        component: () => import('@/pages/msg-notice-set/index.vue'),
        meta: { title: '消息提醒' },
      },
      {
        path: 'logs',
        name: 'MessageNoticeLogs',
        component: () => import('@/pages/msg-notice-set/Logs.vue'),
        meta: { title: '通知日志' },
      },
    ],
  },
]

export default msgNoticeSetRoutes
